import { render, staticRenderFns } from "./dbm_item.vue?vue&type=template&id=2098e47a"
import script from "./dbm_item.vue?vue&type=script&lang=js"
export * from "./dbm_item.vue?vue&type=script&lang=js"
import style0 from "./dbm_item.vue?vue&type=style&index=0&id=2098e47a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports